import Phaser from 'phaser';

import './css/style.css';

import RoundRectanglePlugin from 'phaser3-rex-plugins/plugins/roundrectangle-plugin.js';
import TagTextPlugin from 'phaser3-rex-plugins/plugins/tagtext-plugin.js';
import TextEdit from 'phaser3-rex-plugins/plugins/textedit-plugin.js';

import Boot from './js/scenes/Boot.js';
import Preloader from './js/scenes/Preloader.js';
import Menu from './js/scenes/Menu.js';
import Chapitre1 from './js/scenes/chapitres/Chapitre1.js';
import DebutChapitre2 from './js/scenes/debutchapitre/DebutChapitre2.js';
import Chapitre2 from './js/scenes/chapitres/Chapitre2.js';
import DebutChapitre3 from './js/scenes/debutchapitre/DebutChapitre3.js';
import Chapitre3_0 from './js/scenes/chapitres/Chapitre3_0.js';
import Chapitre3_1 from './js/scenes/chapitres/Chapitre3_1.js';
import DebutChapitre4 from './js/scenes/debutchapitre/DebutChapitre4.js';
import Chapitre4 from './js/scenes/chapitres/Chapitre4.js';
import DebutChapitre5 from './js/scenes/debutchapitre/DebutChapitre5.js';
import Chapitre5_0 from './js/scenes/chapitres/Chapitre5_0.js';
import Chapitre5_1 from './js/scenes/chapitres/Chapitre5_1.js';
import Chapitre5_2 from './js/scenes/chapitres/Chapitre5_2.js';
import Chapitre5_3 from './js/scenes/chapitres/Chapitre5_3.js';
import Chapitre6 from './js/scenes/chapitres/Chapitre6.js';
import Fin from './js/scenes/Fin.js';


//Création du jeu
var game;

window.onload = function () {
    var isMobile = /Mobi|Android/i.test(navigator.userAgent) || Phaser.Input.Touch.enabled;
    var config = {
        autoResize: true,
        width: 1920,
        height: 1080,
        backgroundColor: '#FFFFFF',
        type: Phaser.AUTO,
        parent: "game",
        scale: {
            mode: isMobile ? Phaser.Scale.FIT : Phaser.Scale.FIT,
            autoCenter: Phaser.Scale.CENTER_BOTH
        },
        dom: {
            createContainer: true
        },
        plugins: {
            global: [{
                key: 'rexRoundRectanglePlugin',
                plugin: RoundRectanglePlugin,
                start: true
            },
            {
                key: 'rexTagTextPlugin',
                plugin: TagTextPlugin,
                start: true
            },{
                key: 'rexTextEditPlugin',
                plugin: TextEdit,
                start: true
            },]
        },
        fps:{
            target: 60,
            forceSetTimeOut: true
        },
        scene: [
            Boot, Preloader, Menu, 
            Chapitre1, 
            DebutChapitre2, Chapitre2, 
            DebutChapitre3, Chapitre3_0, Chapitre3_1,
            DebutChapitre4, Chapitre4,
            DebutChapitre5, Chapitre5_0, Chapitre5_1, Chapitre5_2, Chapitre5_3,
            Chapitre6,
            Fin
        ]
    };

    game = new Phaser.Game(config);

    console.log('  __       __|  __  ');
    console.log('__)  (__| (__| (__) ');
    console.log('        |           ');

    game.scene.start("Boot");
}
